import { get } from '@/api/migrated-plans'
import { make } from 'vuex-pathify'

const state = {
  all: {},
  active: 'TP19_P_2019',
  pending: false
}

const mutations = make.mutations(state)

const actions = {
  async fetch({ commit }) {
    commit('SET_PENDING', true)
    const { data } = await get()
    commit(
      'SET_ALL',
      data.reduce((acc, item) => {
        acc[item.id] = item
        return acc
      }, {})
    )
    commit('SET_PENDING', false)
  }
}

const getters = {
  allList: state => Object.values(state.all)
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
